import { render } from "./PodcastCard.vue?vue&type=template&id=dd0b3b22"
import script from "./PodcastCard.vue?vue&type=script&lang=js"
export * from "./PodcastCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__